<template lang="pug">
  .constructor-list-db
    v-card-title
      h3 Конструктор
    v-card-text
      v-layout(row justify-center)
        div.mb-4
          v-btn(large,
            color="success",
            @click.prevent="goCreateNewBD")
            v-icon.mr-2 add
            span Создать
      v-layout(row justify-center).pb-4
        v-flex(xs11)
          v-data-table(
            :headers="headers"
            :items="dbList",
            :loading="loading",
            no-data-text="Нет данных для отображения"
            hide-actions)
            template(slot="items" slot-scope="props")
              td(style="width: 10px") {{ props.index + 1 }}
              td {{ props.item.name }}
                v-btn(icon, small,
                  @click.event="openEditDbDialog(props.item.id, props.item.name, props.item.query)").ml-2
                  v-icon(small, color="grey") border_color
              td {{ props.item.formType }}
              td
                a(@click="viewSchema(props.item.id)") Конструктор
              td
                a(@click="showDialog(props.item.id, props.item.name)" class="red--text") Удалить
    DeleteDialog(
      :show="dialog",
      :loading="deleteDbLoading",
      dispatchType="db",
      @close-dialog="closeDialog",
      @delete-db="removeDb")
      div(slot="title") Вы действительно хотите удалить,<br><b>{{ dbName }}</b>?
    EditDb(
      :show="editDbNameDialog",
      :id="dbId",
      :dbName="dbName",
      :queryTitle="query",
      @close-edit-db-name-dialog="closeEditDbDialog")
</template>

<script>
import EditDb from './EditDb'
const DeleteDialog = () => import('../Common/DeleteDialog/DeleteDialog')
export default {
  name: 'ListDB',
  components: { EditDb, DeleteDialog },
  data() {
    return {
      dialog: false,
      dbName: '',
      dbId: '',
      query: '',
      headers: [
        { text: '№', value: 'id', sortable: false },
        { text: 'Название БД', value: 'name' },
        { text: 'Тип БД', value: 'formType' },
        { text: 'Действие', sortable: false },
        { text: 'Действие', sortable: false }
      ],
      items: [],
      editDbNameDialog: false
    }
  },
  created() {
    this.$store.dispatch('GET_DB_LIST')
  },
  computed: {
    dbList() {
      return this.$store.state.dbConstructor.dbList
    },
    deleteDbLoading() {
      return this.$store.state.dbConstructor.loading.deleteDbLoading
    },
    loading() {
      return this.$store.state.dbConstructor.loading.dbListLoading
    }
  },
  methods: {
    goCreateNewBD() {
      this.$router.push({ path: '/main/constructor/new' })
    },
    viewSchema(id) {
      this.$router.push({ path: `/main/constructor/edit/${id}` })
    },
    removeDb() {
      this.$store.dispatch('REMOVE_DB', this.dbId)
    },
    showDialog(id, name) {
      this.dbName = name
      this.dbId = id
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
      this.dbName = ''
      this.dbId = ''
    },
    openEditDbDialog(id, name, query) {
      this.dbName = name
      this.dbId = id
      this.query = query
      this.editDbNameDialog = true
    },
    closeEditDbDialog() {
      this.editDbNameDialog = false
      this.dbName = ''
      this.dbId = ''
      this.query = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.v-btn {
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/Constructor/ListDB.vue